import axios from "axios";
import { api } from "./api";
import { dedupedFetch } from "./cache";
import { carregarPerfil } from "./pessoa.service";

type SignInRequestData = {
  username: string;
  password: string;
  apiKey?: string;
  grant_type?: string;
};

export function signInRequest(data: SignInRequestData) {
  data["apiKey"] = process.env.REACT_APP_APIKEY;
  data["grant_type"] = "password";

  return api
    .post("/auth/token", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // console.error(error.response.data.message);
      throw new Error("Dados incorretos ou CPF não cadastrado."); //error.response.data;
    });
}

export function fetchUser() {
  return dedupedFetch("fetch-user", async () => {
    const response = await api.get("/player/me/status");
    let user = response.data;
    if (user) {
      user = { ...user, ...(await carregarPerfil()) };
      return user;
    } else {
      document.dispatchEvent(new CustomEvent("signout"));
    }
  }, 5_000).catch((error) => {
    document.dispatchEvent(new CustomEvent("signout"));
  });
}

export async function getUserAcessor(key: string) {
  try {
    let query = [
      {
        $match: {
          matricula: key,
        },
      },
    ];
    const { data } = await api.post(
      "/database/user_accessor__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return null;
    } else {
      return data[0];
    }
  } catch (e: any) {
    throw e;
  } finally {
  }
}

// Detalhe de OUTRO player por id (ex.: autor da indicação GE em
// ConfirmacaoParticipacaoPremio). A normalização do _id (remoção de F/zeros,
// ex-`clearRegistrationUser`) é feita no script do aggregate.
export async function getUserDetail(key: string) {
  return dedupedFetch(`user-detail-${key}`, async () => {
    const { data } = await api.post("/find/player_fields_by_id", { id: key });
    return Array.isArray(data) ? data[0] ?? null : null;
  }, 10_000);
}

export function registerUser(data: any) {
  const payload = {
    _id: `${parseInt(data.username)}`,
    matricula: data.code,
    name: `${data.first_name}`,
    email: data.email,
    password: data.password,
    extra: {
      mobile: data.phone,
      first_name: data.first_name,
      last_name: data.last_name || "",
    },
  };

  return api
    .put("/database/player_register__c", payload)
    .then((response) => {
      const user = response.data;
      return user;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
}

export async function validateUser(payload: any) {
  try {
    const response = await api.put("/database/player_validate__c", payload);
    if (response.data.status === "Unauthorized") {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

const BANCA_VALIDATE_BASIC =
  "Basic NjkzNzI3OTc0NThlNTI3ZWFhYjRiNTFkOjY5ZmI5NjA2MGFmM2E1MmI0NDA3MmUzZg==";

export async function validateBanca(payload: { email: string; forgot?: boolean }) {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/database/banca_validate__c`,
      payload,
      {
        headers: {
          Authorization: BANCA_VALIDATE_BASIC,
          "content-type": "application/json",
          "cache-control": "no-cache",
        },
      }
    );
    if (response.data.status === "Unauthorized") {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function registerBanca(payload: {
  _id: string;
  password: string;
  code: string;
}) {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/database/banca_register__c`,
      {
        _id: payload._id,
        password: payload.password,
        extra: { code: payload.code },
      },
      {
        headers: {
          Authorization: BANCA_VALIDATE_BASIC,
          "content-type": "application/json",
          "cache-control": "no-cache",
        },
      }
    );
    if (response.data.status !== "OK") {
      throw new Error(response.data.message || "Erro ao cadastrar senha.");
    }
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function recoverPassword(id: string) {
  try {
    const response = await api.get(
      `/player/password/change?player=${id.toLocaleLowerCase().trim()}`
    );
    if (response.data.status === "Unauthorized") {
      throw new Error(response.data.message);
    } else {
      return response.data;
    }
  } catch (error: any) {
    throw error;
  }
}

export async function updatePassword(payload: any) {
  try {
    const { username, password, code } = payload;
    const response = await api.put(
      `/player/password?player=${username
        .toLocaleLowerCase()
        .trim()}&new_password=${password}&code=${code}`
    );
    if (response.data.type === "OK") {
      return true;
    } else {
      throw new Error("It was not possible to update your password");
    }
  } catch (error: any) {
    throw new Error("It was not possible to update your password");
  }
}
